/**
 *人事云-设置菜单
 */
export default [
  // {
  //   label: 'policy',  // 政策字典
  //   // permission: 'hr_manage_menu',
  //   img: true,
  //   icon: 'icon-renshiguanli',
  //   id:12,
  //   children: [
  //     {
  //       path: '/bsoc/bsocPolicyDic_init.action?type=MQ--',
  //       label: 'socialSecurityPolicy',  // 社保政策
  //       permission: 'social_security_policy',
  //       icon: 'icon-yonghu',
  //       id:12-1
  //     },
  //     {
  //       path: '/bsoc/bsocPolicyDic_init.action?type=Mg--',
  //       label: 'housingProvidentFundPolicy', // 公积金政策
  //       permission: 'provident_fund_policy',
  //       icon: 'icon-yonghu',
  //       id: 12-2,
  //     }
  //   ]
  // },
  {
    label: 'settings',  // 平台设置
    // permission: 'set_platform',
    img: true,
    icon: 'icon-pingtaishezhi',
    id:8,
    children: [
      {
        path: '/customer/toCustomerInfo.action',
        label: 'companyInformation',  // 公司信息
        permission: 'set_company',
        icon: 'icon-yonghu',
        id:8-1
      },
      {
        path: '/pms/userInfoList.action',
        label: 'accountSettings',  // 账户设置
        permission: 'set_user_info',
        icon: 'icon-yonghu',
        id: 8-2,

      },
      {
        path: '/pms/roleInfoList.action',
        label: 'HRPermissionSettings',  // HR权限设置
        permission: 'set_role',
        icon: 'icon-yonghu',
        id: 8-3,

      },
      {
        path: '/pms/userRoleList.action',
        label: 'userAuthorization',  // 用户授权
        permission: 'set_user_permission',
        icon: 'icon-yonghu',
        id: 8-4,

      },
      {
        path: '/sys/queryParameter.action',
        label: 'systemSettings',  // 系统设置
        permission: 'set_system',
        icon: 'icon-yonghu',
        id: 8-5,

      },
      {
        path: '/sys/code/SysCodeSet.action',
        label: 'codeSettings',  // 代码设置
        permission: 'set_system',
        icon: 'icon-yonghu',
        id: 8-9,

      },
      {
        path: '/sys/infoSet/toJSP.action',
        label: 'messageSettings',  // 消息设置
        permission: 'set_message',
        icon: 'icon-yonghu',
        id: 8-6,

      },
      // {
      //   path: '/sys/compnotice/queryList.action?sysFunctionCode=OTA4NDAwMTY-&readerType=MQ--',
      //   label: 'customerAnnouncement',  // 客户公告
      //   permission: 'set_bulletin',
      //   icon: 'icon-yonghu',
      //   id: 8-8,
      //
      // },
      {
        path: '/pms/userRoleInfoList.action',
        label: 'staffPermissionManagement',  // 员工权限管理
        permission: 'set_emp_permission',
        icon: 'icon-yonghu',
        id: 8-7
      }
    ]
  }
]
